/* eslint-disable no-secrets/no-secrets */
import { useModal, Loader } from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import React, { useCallback, useContext, useState, useRef, useEffect } from 'react';
import { TranslatorContext } from '@jutro/locale';
import { Button } from '@jutro/legacy/components';
import AdditionalInterestDetails from '../AdditionalInterestDetails/AdditionalInterestDetails.jsx';
import messages from './AdditionalInterestComponent.messages.js';
import metadata from './AdditionalInterestComponent.metadata.json5';
import styles from '../AdditionalInterestComponent.module.scss';


function AdditionalInterestComponent(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate, errorDescription, setShowErrorDescription } = props;
    const { authHeader } = useAuthentication();
    const [isLoading, setLoadingState] = useState(false);
    const viewModelService = useContext(ViewModelServiceContext);
    const [additionalInfoVM, setAdditionalInfoVM] = useState();
    const [showAdditionalInterest, setShowAdditionalInterest] = useState(false);
    const { showAlert, showConfirm } = useModal();
    const dwellingAdditionalInterestDTO = 'edge.capabilities.policychange.lob.homeowners.coverables.dto.DwellingAdditionalInterestDTO';
    const { refreshData } = useDataRefresh();
    const [additionalInterest, setAdditionalInterest] = useState([]);
    const additionalInterestData = useRef(additionalInterest);
    const translator = useContext(TranslatorContext);
    // const [errorDescription, setShowErrorDescription] = useState();

    useEffect(() => {
        additionalInterestData.current = _.filter(submissionVM.lobData.homeowners_tfpa.coverables.yourHome.additionalInterests?.value,
            pcd => pcd.type === 'MORTGAGEE' || "MORTGAGEEESCROW_EXT");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const addAdditionalInterest = useCallback(() => {

        const newContact = viewModelService.create({
            tempID: EntityUtil.nextId(),
            type: 'MORTGAGEE',
            isForPolicyChange_Ext: false,
            policyAdditionalInterest: { primaryAddress: { addressType: 'mailingExt', mustStandardize_Ext: false, country: 'US' }, subtype: 'Company' }
        }, 'pc', dwellingAdditionalInterestDTO);

        setAdditionalInfoVM(() => newContact)
        setShowAdditionalInterest(true)
        // OnNext will not call again if there are no changes to the model so setting dummy tag.
        _.set(submissionVM, 'isEditingAdditionalInterest', true)
        updateWizardData(submissionVM)
    }, [submissionVM, updateWizardData, viewModelService])

    const oldVMData = [];
    const saveRepairUpdates = async (updatedData) => {
        const newItem = [...additionalInterestData.current, updatedData.value];

        await saveAdditionalInterest()
        updateWizardData(submissionVM);
        // setShowAdditionalInterest(false);
    };

    const cancelRepairUpdates = () => {
        setAdditionalInfoVM(oldVMData);
        setShowAdditionalInterest(false);
    };

    const getSelectedPositions = () => _.filter(additionalInterestData.current.map((ai) => ai.mortgagePosition_ext), item => item !== undefined)

    const getPriority = (priority) => {

        switch (priority) {
            case 'FirstMortgagee': return 5;
            case 'SecondMortgagee': return 10;
            case 'ThirdMortgagee': return 15;
            default: return 0;
        }
    }

    // Validate mortgage positions making sure they are ordered sequentially.This will avoid quote corrupt
    const validatePositions = (addInterest, remove) => {

        const mortgagePositions = getSelectedPositions();
        let sum = _.sumBy(mortgagePositions, a => (a != null ? getPriority(a) : 0));

        if (addInterest) {
            if (addInterest.mortgagePosition_ext) {
                if (remove) {
                    sum -= getPriority(addInterest.mortgagePosition_ext);
                } else {
                    sum += getPriority(addInterest.mortgagePosition_ext);
                }
            }
        }

        if (sum === 0 || sum === 5 || (sum === 15 && mortgagePositions.length > 0) || sum === 30) {
            return true;
        }

        return false;
    }

    const saveAdditionalInterest = async () => {
        setLoadingState(true);

        if (validatePositions(additionalInfoVM.value, false)) {
            const policyContactDetails = submissionVM.lobData.homeowners_tfpa.coverables.yourHome.additionalInterests;

            additionalInterestData.current.push(additionalInfoVM.value)
            policyContactDetails.value = (additionalInterestData.current);
            _.set(submissionVM, 'lobData.homeowners_tfpa.coverables.yourHome.additionalInterests.value', additionalInterestData.current)
            updateWizardData(submissionVM);
            setShowAdditionalInterest(false);
        } else {
            showAlert({
                title: messages.mortgageValidationTitle,
                message: messages.mortgageValidationMsg,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.close,
            }).catch(_.noop);
        }

        setLoadingState(false);
    }



    const deleteAdditionalInterest = async (item, index) => {
        setShowErrorDescription([]);

        if (!validatePositions(item, true)) {
            showAlert({
                title: messages.mortgageValidationTitle,
                message: messages.mortgageValidationMsg,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.close,
            }).catch(_.noop);
        } else {
            const policyContactDetails = submissionVM.lobData.homeowners_tfpa.coverables.yourHome.additionalInterests;

            additionalInterestData.current = additionalInterestData.current.filter((_, i) => i !== index);
            policyContactDetails.value = (additionalInterestData.current);
            setAdditionalInterest(additionalInterestData.current)
        }

        
    }

    const deleteRow = async (item, index) => {
        showConfirm({
            title: messages.removeAdditionalInterest,
            message: messages.removeAddlInterestMessage,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.yesModel,
            cancelButtonText: messages.cancel,
            className: styles.jut__Button__filled,
        }).then(async (results) => {

            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }

            await deleteAdditionalInterest(item, index);

            // DE16558
            const addlInterests = submissionVM.value.bindData_TFPA?.additionalInterests_Ext.findIndex((ai) => ai.accountContactDTO.publicID === item.policyAdditionalInterest.publicID);

            submissionVM.value.bindData_TFPA?.additionalInterests_Ext.splice(addlInterests, 1);
            updateWizardData(submissionVM);

            return true;
        }, _.noop)
    };

    const formatInterestType = (type) => {
        switch (type) {
            case 'MORTGAGEE':
                return translator(messages.mortgagee);
            case 'ALTERNATEPAYOR_EXT':
                return translator(messages.alternatePayor); // DE18024
            case 'MORTGAGEEESCROW_EXT':
                return translator(messages.mortgageeEscrow);
            default:
                return type;
        }
    };

    const formatMortgageType = (type) => {

        switch (type) {
            case 'FirstMortgagee': return translator(messages.firstMortgagee);
            case 'SecondMortgagee': return translator(messages.secondMortgagee);
            case 'ThirdMortgagee': return translator(messages.thirdMortgagee);
            default: return type;
        }
    }

    const getName = (item) => item.policyAdditionalInterest.contactName;

    const getInterestType = (item) => {
        if (!item && !item.type) {
            return undefined;
        }

        return formatInterestType(item.type);
    }

    const getLoanNumber = (item) => item.contractNumber;

    const getMortgagePosition = (item) => {

        if (!item && !item.mortgagePosition_ext) {
            return undefined
        }

        return formatMortgageType(item.mortgagePosition_ext)
    }

    const getDescriptionOfInterest = (item) => item.description;

    const actionButtons = (item, index) => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
                className={styles.buttons}
                type="text"
                icon="gw-delete"
                onClick={() => deleteRow(item, index)}
                aria-label="Delete Row"
            />
        </div>
    );

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        add: {
            visible: !showAdditionalInterest
        },
        additionalInterestSection: {
            visible: showAdditionalInterest,
            item: additionalInfoVM,
            saveData: saveRepairUpdates,
            cancelData: cancelRepairUpdates,
            isInvalid: findInvalidComponent,
            showErrors,
            onValidate
        },
        additionalInterestTable: {
            data: additionalInterestData.current
        },
        infoMessage: {
            message: errorDescription
        },

    };

    const writeValue = useCallback(
        (value, path) => {
            _.set(submissionVM, `${path}.value`, value);
            updateWizardData(submissionVM);
            refreshData();
        },
        [submissionVM, refreshData, updateWizardData]
    );

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: { addtionalInterestDetailsComponent: AdditionalInterestDetails },
        resolveCallbackMap: {
            onAdd: addAdditionalInterest,
            getName,
            getInterestType,
            getMortgagePosition,
            getLoanNumber,
            actionButtons,
            getDescriptionOfInterest
        },
    };

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }


    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={submissionVM}
            overrideProps={overrideProps}
            onModelChange={updateWizardData}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            onValueChange={writeValue}
        />
    );
}

export default AdditionalInterestComponent;
